export default ({ Factory }) => ({

  /**
   * Проверка оплаты канала
   * @param {String} id - идентификатор канала
   */
  check: (id) => Factory[id].get(),

  /**
   * Подписка на канал
   * @param {String} id - идентификатор канала
   */
  create: (id) => Factory[id].post(),

  /**
   * Отписка от канала
   * @param {String} id - идентификатор канала
   * @param {String} reason - причина отписки
   */
  remove: (id, reason) => Factory[id][reason].delete(),

  /**
   * Получение списка подписок
   */
  list: () => Factory.list.get(),

  /**
   * Получение списка причин отписки
   */
   reasons: () => Factory.reasons.get()
})